import PropTypes from 'prop-types';
import Modal from './Modal';
import MotiliButton from '../../components-v2/buttons/MotiliButton';
import MotiliButtonContainer from '../buttons/MotiliButtonContainer';

const MAX_DISPLAY_SECONDS = 300; // 5 minutes in seconds

export default function TimeoutModal({ handleExtend, handleClose, expiredIn }) {
    const capped = Math.min(expiredIn, MAX_DISPLAY_SECONDS);
    const secondsRemain = capped % 60;
    const minutesExpired = (capped - secondsRemain) / 60;
    const timeDisplay =
        minutesExpired > 0
            ? `${minutesExpired}:${
                  secondsRemain < 10 ? `0${secondsRemain}` : secondsRemain
              } minutes`
            : `${secondsRemain} seconds`;
    return (
        <Modal
            controlId='session-inactivity-modal'
            headerStyles={{ fontSize: 32 }}
            header='Session Inactivity'
            onCloseClick={handleClose}
            showClose={false}
            footer={
                <MotiliButtonContainer>
                    <MotiliButton
                        text={`I'm Still Working`}
                        onClick={handleExtend}
                    />
                </MotiliButtonContainer>
            }
        >
            <div>
                The system has not detected any activity for the past hour and
                will automatically log you out in the{' '}
                <b>next{` ${timeDisplay}`}</b>{' '}
            </div>
        </Modal>
    );
}
TimeoutModal.propTypes = {
    handleExtend: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
    expiredIn: PropTypes.number.isRequired,
};
